/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Consents_ChannelInputs */

const cs_clients_consents_channel = /** @type {(inputs: Clients_Consents_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanál`)
};

const en_clients_consents_channel = /** @type {(inputs: Clients_Consents_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Clients_Consents_ChannelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_consents_channel = /** @type {((inputs?: Clients_Consents_ChannelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Consents_ChannelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_consents_channel(inputs)
	return cs_clients_consents_channel(inputs)
});